const adriverExtentionLoad = (a: number, b: number | null, containerId: string) => {
  const container = document.getElementById(containerId);
  if (!container) {
    return false;
  }
  if (a === 0 && container) {
    container.style.height = '0';
    container.style.display = 'none';
  } else {
    container.style.height = '';
    container.style.display = '';
  }
};

export default adriverExtentionLoad;
